import { setBooleanFeatureFlagResolver } from '@atlaskit/platform-feature-flags';
import { fg } from '@atlassian/jira-feature-gating';
import { ff } from '../get-feature-flag-value';

export const initPlatformFeatureFlags = () => {
	if (ff('fix_jira_ssr_platform_ff_oxim4')) {
		setBooleanFeatureFlagResolver((flagKey) => fg(flagKey) || ff(flagKey));
	}
};
